"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChoiceOption = exports.ChoiceOptionField = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var clsx_1 = __importDefault(require("clsx"));
var O = __importStar(require("fp-ts/Option"));
var function_1 = require("fp-ts/function");
var React = __importStar(require("react"));
var nameFieldsBuilder_1 = require("../../nameFieldsBuilder");
var fieldMaker_1 = require("../fieldMaker");
require("./choiceOption.css");
var ChoiceOptionField = /** @class */ (function (_super) {
    __extends(ChoiceOptionField, _super);
    function ChoiceOptionField(props) {
        var _this = _super.call(this, props) || this;
        _this.inputRef = React.createRef();
        _this.selectValue = function () {
            _this.props.onChange && _this.props.onChange(_this.props.value === 1 ? 0 : 1, !(_this.props.value === 1));
        };
        _this.onClick = function () {
            (0, function_1.pipe)(O.fromNullable(_this.inputRef.current), O.map(function (c) { return c.focus(); }));
            _this.selectValue();
        };
        _this.onLabelClick = function () {
            if (_this.props.interactiveText) {
                _this.onClick();
            }
        };
        _this.state = {
            hasFocus: false,
        };
        return _this;
    }
    ChoiceOptionField.prototype.render = function () {
        var _this = this;
        return ((0, jsx_runtime_1.jsx)("span", __assign({ className: "choice-option-wrapper" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, clsx_1.default)("theme-".concat(this.props.theme), { checked: this.props.value === 1 }) }, { children: [(0, jsx_runtime_1.jsx)("input", { className: (0, clsx_1.default)({ disabled: this.props.disabled ? true : false }), name: (0, nameFieldsBuilder_1.buildFieldName)(this.props.name), type: this.props.type, ref: this.inputRef, onChange: this.selectValue, onFocus: function () { return _this.setState({ hasFocus: true }); }, onBlur: function () { return _this.setState({ hasFocus: false }); }, checked: this.props.value === 1 }), (0, jsx_runtime_1.jsx)("span", __assign({ onClick: this.onLabelClick, className: (0, clsx_1.default)('choice-option', "type-".concat(this.props.type), { checked: this.props.value === 1 }, { disabled: this.props.disabled ? true : false }, { focus: this.state.hasFocus }, { not_interactive: !this.props.interactiveText }, (0, react_1.css)(this.props.customStyle)) }, { children: this.props.label }))] })) })));
    };
    ChoiceOptionField.defaultProps = {
        value: 0,
        theme: 'default',
        interactiveText: true,
    };
    return ChoiceOptionField;
}(React.PureComponent));
exports.ChoiceOptionField = ChoiceOptionField;
exports.ChoiceOption = (0, fieldMaker_1.makeField)(ChoiceOptionField);
//# sourceMappingURL=ChoiceOption.js.map